import { RouteComponentProps } from "@gatsbyjs/reach-router";
import { APButton, APCard, APColumn, APRow, getIt, handleErrorMessage, showErrorDialog } from "ap-components";
import ActivationApis from "../../Services/ActivationService";

export default function FakeDigioLink(props: RouteComponentProps<{ mandateId: string }>) {

    if (!props.mandateId) {
        window.history.back();
        showErrorDialog("MandateId not provided");
        return <></>
    }

    async function digioRequest(status: string, message?: string) {
        if (!props.mandateId) {
            return
        }

        try {
            const res = await getIt(ActivationApis).digioRedirect(props.mandateId, { status, message })
            console.log(res);
        } catch (error) {
            handleErrorMessage(error)
        }
    }

    return (<APColumn mainAxisSize="max" mainAxisAlignment="center" crossAxisAlignment="center">
        <APCard width="400px" style={{ borderRadius: "8px" }}>
            <APRow mainAxisAlignment="spaceEvenly" gap="20px" >
                <APButton style={{ padding: "10px 20px" }} size="large" color="primary" variant="contained"
                    onClick={async () => {
                        window.location.href = `/mandate/${props.mandateId}/success`;
                    }}
                >
                    Success
                </APButton>
                <APButton style={{ padding: "10px 20px" }} size="large" color="primary" variant="contained"
                    onClick={async () => {
                        window.location.href = `/mandate/${props.mandateId}/failure?msg=CANCELLED_MANUALLY_BY_CLIENT`
                    }}
                >
                    Failure
                </APButton>
            </APRow>
        </APCard>

    </APColumn>)
}